import React from "react";
import HeaderNavbar from "../header/HeaderNavbar";
import Getstarted from "../getstarted/Getstarted";
import Carddata from "../../components/card/Carddata";
import Videocard from "../../components/Videocard/Videocard";
import Career from "../career_timeline/Career";
import Video from "../../assets/video/GetStarted.mp4";
import Servicecard from "../../components/servicecard/Servicecard";
// import styles from "./Homepage.module.css";
import Subscribenewsletter from "../subscribenewsletter/Subscribenewsletter";
import Testimonials from "../testimonials/Testimonials";
import BannerCard from "../bannercard/BannerCard";
import DownloadBanner from "../../components/downloadbanner/DownloadBanner";
import { office_banner } from "../../controller/Images";
import Footer from "../footer/FooterNavbar";
import DataCard from "../datacard/DataCard";
import LetsTalk from "../../assets/images/LetsTalk.png";
import ImageContentSection from "../../components/imagecontentsection/ImageContentSection";
import ImageContentOverlap from "../../components/imagecontentoverlap/ImageContentOverlap";
import CaseStudies from "../casestudies/CaseStudies";
import SeoPage from "../../components/seo/SeoPage";
import OverlayCard from "../../components/OverlayCard/OverlayCard";
import {
  unleash,
  Partnership,
  Security,
  Cloud,
  Obsession,
  Engineering,
} from "../../controller/Images";
// This Home_page design
function Homepage() {
  return (
    <>
      <SeoPage
        title="Bharat Clouds Private Limited - Managed IT services, ERP services, Application development "
        description="As a professional IT services provider Bharat Clouds Private Limited offers expertise in web and mobile application development, ERP mangaed services, managed IT services"
      />
      <div
        style={{
          maxWidth: "1480px",
          margin: "0 auto",
          minHeight: "100vh",
        }}
      >
        <div>
          <HeaderNavbar from={"HOME"} />
        </div>
        <div>
          {" "}
          <Getstarted />{" "}
        </div>
        <div>
          {" "}
          <CaseStudies />{" "}
        </div>
        {/* <div>
          <DataCard />{" "}
        </div> */}
        {/* <div>
          <Videocard
            Video={Video}
            title="Get to Know Us"
            subHeading="Driven By Passion For Excellence.
Deliver Results."
            description={[
              {
                id: 1,
                text: "Bharat Clouds is a professional IT and ITES company which is engaged in providing innovative and cost-effective tailor-made solutions to its customers to helps in their efforts to modernize their systems and processes for quicker decisions and more efficient services, apart from bringing about cost reductions and reaching their business goals with greater speed.",
              },
              {
                id: 2,
                text: "Bharat Clouds recognizes the fact that the process of technological evolution is constant and rapid. The company’s organic partnership approach help in incremental but definite & tangible enhanced use of technology in day-to-day business operations in pursuit of their business objectives rather than going in for large costly all-or-nothing systems that promise to do everything right away !!",
              },
              // {
              //   id: 3,
              //   text: "With a focus on security, scalability, and sustainability, Bharat Clouds offers end-to-end services designed to future-proof your organization. From strategic IT consulting to full-cycle software development, we ensure your technology foundation is not only strong but ready to evolve with changing market demands.",
              // },
            ]}
          />
        </div> */}
        {/* <div>
          <Career />
        </div> */}
        {/* <div>
        <Servicecard 
        sliceEndNum={3} />
      </div> */}
        {/* <div>
          <Testimonials />
        </div> */}
        {/* <div>
        <Videocard
          Video="https://www.w3schools.com/html/mov_bbb.mp4"
          title="Seamless Cloud Migration"
          description="Our cloud-native solutions are designed to be flexible, secure, and aligned with your unique goals, enabling a smooth transition to modern digital environments. Whether you're moving legacy systems or building new cloud-based platforms, Bharat Clouds provides expert guidance and technical support every step of the way. Our future-ready approach ensures your infrastructure is not only optimized for today's needs but also adaptable for tomorrow's growth. Partner with us to unlock the full value of cloud technology and drive sustainable digital transformationAt Bharat Clouds, we specialize in helping businesses migrate their infrastructure to the cloud with minimal disruption and maximum efficiency."
          reverse={true}
        />
      </div> */}
        <div>
          <div
            className="text-center mt-5 custom-space custom-space-padding"
          >
            <h5 className="main_heading mt-4">Our Blueprint for Success</h5>
          </div>
          {/* <div className="px-5">
            <ImageContentOverlap
              type="type1"
              title="Customer Obsession"
              content={[
                "We start by mapping real customer journeys to uncover pain points and opportunities. We combine qualitative research, analytics, and frontline feedback to understand what customers really need at each touchpoint. Fast prototypes and pilots let us test ideas quickly and learn from real-world behavior before scaling. We prioritize improvements that move key metrics conversion, retention, and NPS so every change ties back to measurable business impact. Ongoing user validation ensures solutions remain relevant as customer expectations evolve.",
              ]}
              image="https://images.unsplash.com/photo-1521737604893-d14cc237f11d?q=80&w=870&auto=format&fit=crop"
            />

            <ImageContentOverlap
              type="type2"
              title="Engineering Excellence"
              content={[
                "We build reliable, maintainable systems using proven architectures and strong automation. Our engineers apply modular design, clear APIs, and coding standards to reduce complexity and speed future development. Automated testing, CI/CD, and comprehensive monitoring let us deliver value rapidly while keeping systems stable and predictable. This disciplined approach minimizes technical debt and lowers operational costs over time. Regular architecture reviews and refactoring ensure the platform remains resilient and extensible as requirements grow.",
              ]}
              image="https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=870&auto=format&fit=crop"
            />

            <ImageContentOverlap
              type="type1"
              title="Cloud & AI-First Thinking"
              content={[
                "We design solutions to thrive in the cloud and use AI where it clearly improves outcomes from smarter recommendations to automated workflows. Architectures are right-sized for performance and cost, leveraging managed cloud services to accelerate delivery and reduce operational burden. We integrate data pipelines, model evaluation, and monitoring so AI improves continuously and responsibly. Practical AI use cases focus on driving KPIs like revenue, efficiency, and customer satisfaction rather than novelty. The result is scalable platforms that deliver faster insights and adapt as data and business needs evolve.",
              ]}
              image="https://images.unsplash.com/photo-1517148815978-75f6acaaf32c?q=80&w=870&auto=format&fit=crop"
            />

            <ImageContentOverlap
              type="type2"
              title="Security & Trust by Design"
              content={[
                "Security is embedded into every stage of the design and delivery process, not added as an afterthought. We enforce strong identity and access controls, encrypt data at rest and in transit, and apply network segmentation to limit exposure. Compliance with standards such as ISO 9001 and ISO 27001 guides our controls and documentation, supporting regulatory alignment and audits. Threat modeling, regular security reviews, and automated checks are integrated into the CI/CD pipeline to catch issues early. This layered approach protects customer data, preserves trust, and keeps platforms resilient against evolving threats.",
              ]}
              image="https://images.unsplash.com/photo-1550751827-4bd374c3f58b?q=80&w=870&auto=format&fit=crop"
            />

            <ImageContentOverlap
              type="type1"
              title="Co-creation & Long-Term Partnership"
              content={[
                "We work alongside your team from strategy through delivery and beyond, combining your domain expertise with our engineering and cloud/AI capabilities. Engagements are structured around shared goals, clear KPIs, and transparent decision-making so value is visible early and often. We use iterative delivery and joint governance to adapt plans based on real outcomes and changing priorities. After launch, our managed services, proactive monitoring, and continuous improvement programs ensure the solution keeps delivering value as your business evolves. Long-term partnerships let us anticipate needs and accelerate future initiatives together.",
              ]}
              image="https://images.unsplash.com/photo-1522071820081-009f0129c71c?q=80&w=870&auto=format&fit=crop"
            />
          </div> */}
        <div className="px-3 px-md-5">
            <OverlayCard
              index={0} // Add this!
              title="Customer Obsession"
              description="We start by mapping real customer journeys to uncover pain points and opportunities. We combine qualitative research, analytics, and frontline feedback to understand what customers really need at each touchpoint. Fast prototypes and pilots let us test ideas quickly and learn from real-world behavior before scaling. We prioritize improvements that move key metrics conversion, retention, and NPS so every change ties back to measurable business impact. Ongoing user validation ensures solutions remain relevant as customer expectations evolve."
              image={Obsession}
              imageLeft={true}
            />

            <OverlayCard
              index={1} // Add this!
              title="Engineering Excellence"
              description="We build reliable, maintainable systems using proven architectures and strong automation. Our engineers apply modular design, clear APIs, and coding standards to reduce complexity and speed future development. Automated testing, CI/CD, and comprehensive monitoring let us deliver value rapidly while keeping systems stable and predictable. This disciplined approach minimizes technical debt and lowers operational costs over time. Regular architecture reviews and refactoring ensure the platform remains resilient and extensible as requirements grow."
              image={Engineering}
              imageLeft={false}
            />

            <OverlayCard
              index={2} // Add this!
              title="Cloud & AI-First Thinking"
              description="We design solutions to thrive in the cloud and use AI where it clearly improves outcomes from smarter recommendations to automated workflows. Architectures are right-sized for performance and cost, leveraging managed cloud services to accelerate delivery and reduce operational burden. We integrate data pipelines, model evaluation, and monitoring so AI improves continuously and responsibly. Practical AI use cases focus on driving KPIs like revenue, efficiency, and customer satisfaction rather than novelty. The result is scalable platforms that deliver faster insights and adapt as data and business needs evolve."
              image={Cloud}
              imageLeft={true}
            />

            <OverlayCard
              index={3} // Add this!
              title="Security & Trust by Design"
              description="Security is embedded into every stage of the design and delivery process, not added as an afterthought. We enforce strong identity and access controls, encrypt data at rest and in transit, and apply network segmentation to limit exposure. Compliance with standards such as ISO 9001 and ISO 27001 guides our controls and documentation, supporting regulatory alignment and audits. Threat modeling, regular security reviews, and automated checks are integrated into the CI/CD pipeline to catch issues early. This layered approach protects customer data, preserves trust, and keeps platforms resilient against evolving threats."
              image={Security}
              imageLeft={false}
            />

            <OverlayCard
             index={4} // Add this!
              title="Co-creation & Long-Term Partnership"
              description="We work alongside your team from strategy through delivery and beyond, combining your domain expertise with our engineering and cloud/AI capabilities. Engagements are structured around shared goals, clear KPIs, and transparent decision-making so value is visible early and often. We use iterative delivery and joint governance to adapt plans based on real outcomes and changing priorities. After launch, our managed services, proactive monitoring, and continuous improvement programs ensure the solution keeps delivering value as your business evolves. Long-term partnerships let us anticipate needs and accelerate future initiatives together."
              image={Partnership}
              imageLeft={true}
            />
          </div>
        </div>
        <div className="mt-5">
          <BannerCard
            title="Value-Driven Partnership"
            texts={[
              "At Bharat Clouds, we help establish a Digital Nerve that acts as a strategic  differentiator for our clients. By building flexible, future-ready architectures, we enable seamless connectivity across systems, data, and operations, allowing enterprises to sense change, respond faster, and make informed decisions in real time.",
              "Through our expertise in digital transformation, cloud infrastructure, data analytics, artificial intelligence, and managed services, we simplify and modernize legacy environments to make them truly digital-ready. Our agile engineering approach embeds DevOps and strong engineering disciplines to accelerate delivery and improve reliability. We design elastic infrastructure using hybrid cloud, managed, and partially managed service models, and create unified data architectures powered by advanced analytics and real-time insights. Together, these capabilities help organizations reduce risk, improve efficiency, and achieve sustainable growth in an ever-evolving digital landscape.",
            ]}
            buttontext="Partner With Us"
            banner2={LetsTalk}
            navigateTo="/lets-talk"
            // background="grey"
          />
        </div>
        <div className="mb-5">
          <BannerCard
            banner={unleash}
              bannerPosition="center 78%"
            texts={[
              "Step into a career with Bharat Clouds, where a team of passionate software consultants, infrastructure architects, and domain experts committed to delivering innovative, scalable, and reliable solutions. Leveraging the latest tools, frameworks, and agile methodologies, we tackle complex business challenges with creativity, collaboration, and excellence. From building robust cloud platforms and intuitive mobile applications to ensuring top-tier software quality, our team thrives on driving impact and exceeding client expectations. Join us to advance your career, work with cutting-edge technologies, and be part of a culture that values knowledge, innovation, and shared success.",
            ]}
            title="Unleash Your Potential with Bharat Clouds"
            buttontext="Join Our Team"
            navigateTo="/join-our-team"
            background="grey"
          />
        </div>
        <div>
          <DownloadBanner bannerText="Learn more at a glance - download our brochures." />
        </div>
        {/* <div>
          <Subscribenewsletter />
        </div> */}
      </div>

      <Footer from={"HOME"} />
    </>
  );
}

export default Homepage;
